import { render } from "./SaleQuantity.vue?vue&type=template&id=4bcceeac"
import script from "./SaleQuantity.vue?vue&type=script&lang=js"
export * from "./SaleQuantity.vue?vue&type=script&lang=js"

import "./SaleQuantity.vue?vue&type=style&index=0&id=4bcceeac&lang=css"
import "./SaleQuantity.vue?vue&type=style&index=1&id=4bcceeac&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__